// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JjrG","col":"styles_col__ZHY54"};